var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalysingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 304,
    height: 104,
    viewBox: "0 0 304 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1773_78856)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.029 102H42.3059L44.5614 100.54C46.6269 99.2036 48.5047 97.5972 50.1452 95.7635C52.0641 93.6185 53.6363 91.187 54.8051 88.5569L55.0692 87.9625C56.2377 85.333 57.0438 82.557 57.4654 79.7106L58.093 75.4737L42.3059 69.7895L30.3077 74.2105M41.0429 62.8421V48.9474L51.7782 39.3117V16.7368H65.6708V26.8421L89.0358 6L138.292 48.3158V75.4737V75.4737C138.292 90.1238 150.168 102 164.818 102H1216M35.9911 84.3158L41.0429 88.7368L48.6208 81.1579M25.8873 75.4737L26.4201 80.2695C26.6951 82.7446 27.311 85.1698 28.2505 87.476L28.3664 87.7607C29.6477 90.906 31.5447 93.7635 33.9459 96.1651V102H0",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1773_78856"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 304,
    height: 104,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalysingIcon);
export default __webpack_public_path__ + "static/media/analysing-icon.a6e0975d.svg";
export { ForwardRef as ReactComponent };